var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 233,
    height: 38,
    viewBox: "0 0 233 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_4708_66)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.8972 6.66377V36.6989H51.3463V17.7048L58.7358 30.438H63.4831L70.8726 17.7048V36.6989H77.3217V6.66377H71.2757L61.199 24.008L51.1671 6.66377H44.8972ZM81.8233 25.4886C81.8233 32.257 86.7945 37.3334 93.9153 37.3334C98.3491 37.3334 102.962 35.2606 104.664 31.2418L99.0656 29.5497C97.9012 31.3264 96.1994 32.3416 93.9601 32.3416C90.5564 32.3416 88.6755 29.9727 88.1828 27.0115H105.156V25.5309C105.156 18.7624 100.812 13.7284 93.6018 13.7284C86.5258 13.7284 81.8233 19.1431 81.8233 25.4886ZM93.6018 18.2971C96.6024 18.2971 98.3043 20.4122 98.7074 23.035H88.2724C88.8098 20.4122 90.6012 18.2971 93.6018 18.2971ZM107.084 14.3629V19.1431H111.114V29.5497C111.114 34.3722 114.025 37.3334 119.041 37.3334C121.012 37.3334 123.027 36.8681 124.729 35.8528L123.609 31.411C122.534 31.834 121.46 32.1724 120.295 32.1724C118.101 32.1724 117.384 30.6918 117.384 28.8305V19.1431H123.833V14.3629H117.384V6.74838H111.114V14.3629H107.084ZM135.548 37.3334C138.235 37.3334 141.101 36.3181 142.535 34.0761L142.714 36.6989H148.312V23.1619C148.312 17.3241 143.968 13.7284 138.056 13.7284C133.712 13.7284 129.009 15.9281 127.979 20.2007L133.578 21.2583C134.249 19.4816 136.041 18.5932 137.966 18.5932C140.698 18.5932 142.221 20.3699 142.221 22.8658V24.1772C140.385 23.5426 138.817 23.2042 136.847 23.2042C132.144 23.2042 127.128 25.3617 127.128 30.3534C127.128 34.7952 131.249 37.3334 135.548 37.3334ZM133.309 30.0573C133.309 27.8152 135.951 27.1807 137.877 27.1807C138.638 27.1807 139.355 27.2653 140.116 27.3922C140.878 27.5614 141.549 27.7729 142.221 28.0267V28.2383C142.221 30.988 139.803 32.7647 137.071 32.7647C135.324 32.7647 133.309 31.9609 133.309 30.0573ZM153.308 5.14087V36.6989H159.086L159.265 33.7799C160.922 36.1489 163.609 37.3334 166.565 37.3334C173.506 37.3334 177.806 31.4533 177.806 25.404C177.806 19.3547 173.641 13.7284 166.923 13.7284C163.967 13.7284 161.37 14.9551 159.578 17.1972V5.14087H153.308ZM165.445 19.0585C169.252 19.0585 171.401 22.2312 171.401 25.5309C171.401 28.8728 169.162 32.0032 165.445 32.0032C161.683 32.0032 159.489 28.7882 159.489 25.5309C159.489 22.1889 161.728 19.0585 165.445 19.0585ZM181.911 14.3629V36.6989H188.181V23.8811C188.181 21.1314 190.107 19.0585 193.018 19.0585C196.108 19.0585 197.228 21.4698 197.228 24.0503V36.6989H203.498V23.2888C203.498 18.0856 200.676 13.7284 194.854 13.7284C191.988 13.7284 189.346 14.8705 187.868 17.2395L187.689 14.3629H181.911ZM208.503 5.14087V36.6989H214.28L214.459 33.7799C216.116 36.1489 218.803 37.3334 221.759 37.3334C228.701 37.3334 233 31.4533 233 25.404C233 19.3547 228.835 13.7284 222.117 13.7284C219.161 13.7284 216.564 14.9551 214.772 17.1972V5.14087H208.503ZM220.639 19.0585C224.446 19.0585 226.596 22.2312 226.596 25.5309C226.596 28.8728 224.356 32.0032 220.639 32.0032C216.877 32.0032 214.683 28.7882 214.683 25.5309C214.683 22.1889 216.922 19.0585 220.639 19.0585Z",
    fill: "url(#paint0_linear_4708_66)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3926 6.63208H19.5935V7.95404H22.3926V6.63208Z",
    fill: "url(#paint1_linear_4708_66)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4918 9.276H17.4941V10.598H24.4918V9.276Z",
    fill: "url(#paint2_linear_4708_66)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.09705 18.5297H7.69751V19.8516H9.09705V18.5297Z",
    fill: "url(#paint3_linear_4708_66)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8961 18.5297H10.4966V19.8516H11.8961V18.5297Z",
    fill: "url(#paint4_linear_4708_66)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6952 18.5297H13.2957V19.8516H14.6952V18.5297Z",
    fill: "url(#paint5_linear_4708_66)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4943 18.5297H16.0947V19.8516H17.4943V18.5297Z",
    fill: "url(#paint6_linear_4708_66)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2933 18.5297H18.8938V19.8516H20.2933V18.5297Z",
    fill: "url(#paint7_linear_4708_66)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0924 18.5297H21.6929V19.8516H23.0924V18.5297Z",
    fill: "url(#paint8_linear_4708_66)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8915 18.5297H24.4919V19.8516H25.8915V18.5297Z",
    fill: "url(#paint9_linear_4708_66)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6906 18.5297H27.291V19.8516H28.6906V18.5297Z",
    fill: "url(#paint10_linear_4708_66)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4896 18.5297H30.0901V19.8516H31.4896V18.5297Z",
    fill: "url(#paint11_linear_4708_66)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.2887 18.5297H32.8892V19.8516H34.2887V18.5297Z",
    fill: "url(#paint12_linear_4708_66)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3949 27.7834H13.9954V29.1054H15.3949V27.7834Z",
    fill: "url(#paint13_linear_4708_66)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3926 23.1566V31.0884C22.3926 31.485 22.6725 31.7494 23.0923 31.7494H32.8891C33.309 31.7494 33.5889 31.485 33.5889 31.0884V23.1566C33.5889 22.76 33.309 22.4956 32.8891 22.4956H23.0923C22.6725 22.4956 22.3926 22.7607 22.3926 23.1566ZM23.7921 27.7835H27.291V30.4274H23.7921V27.7835ZM28.6905 30.4274V27.7835H32.1893V30.4274H28.6905ZM32.1893 26.4615H28.6905V23.8176H32.1893V26.4615ZM27.291 23.8176V26.4615H23.7921V23.8176H27.291Z",
    fill: "url(#paint14_linear_4708_66)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1871 35.7153V33.7323C39.1871 33.3357 38.9072 33.0713 38.4873 33.0713H37.0878V17.2077H39.1871C39.6069 17.2077 39.8868 16.9433 39.8868 16.5467V14.1011C39.8868 13.9028 39.8169 13.7045 39.6069 13.5723L34.2887 9.87082V2.00512C34.2887 1.60853 34.0088 1.34413 33.5889 1.34413H27.9908C27.5709 1.34413 27.291 1.60853 27.291 2.00512V4.91344L21.4129 0.815347C21.133 0.617052 20.8531 0.617052 20.5732 0.815347L2.86905 13.2418H2.79908V13.3079L2.37922 13.5723C2.16929 13.7045 2.09931 13.9028 2.09931 14.1011V16.5467C2.09931 16.9433 2.37921 17.2077 2.79908 17.2077H4.89838V33.0713H3.49885C3.07898 33.0713 2.79908 33.3357 2.79908 33.7323V35.7153H0V37.0372H3.49885H38.4873H41.9861V35.7153H39.1871ZM32.8891 2.6661V3.32708H28.6905V2.6661H32.8891ZM28.6905 4.64905H32.8891V8.87934L28.6905 5.90492V4.64905ZM3.49885 14.5638H31.4896V13.2418H5.17829L20.9931 2.13797L38.4873 14.4323V15.8864H36.388H5.59815H3.49885V14.5638ZM6.29792 17.2077H35.6882V33.0713H18.194V23.8176H19.5935V22.4956H17.4942H9.79677H7.69746V23.8176H9.097V33.0713H6.29792V17.2077ZM10.4965 23.8176H16.7945V33.0713H10.4965V23.8176ZM4.19861 35.7153V34.3933H5.59815H9.79677H17.4942H36.388H37.7875V35.7153H4.19861Z",
    fill: "url(#paint15_linear_4708_66)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_4708_66",
    x: 0,
    y: 0.666626,
    width: 237,
    height: 40.6667,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 22
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.376471 0 0 0 0 0.376471 0 0 0 0 0.376471 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4708_66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4708_66",
    x1: 79.587,
    y1: 8.57475,
    x2: 192.672,
    y2: 25.566,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC3E88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.418735,
    stopColor: "#B840AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#843FE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4708_66",
    x1: 20.1097,
    y1: 6.77309,
    x2: 21.8254,
    y2: 6.8665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC3E88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.418735,
    stopColor: "#B840AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#843FE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4708_66",
    x1: 18.7846,
    y1: 9.41701,
    x2: 23.0083,
    y2: 9.99192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC3E88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.418735,
    stopColor: "#B840AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#843FE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4708_66",
    x1: 7.95561,
    y1: 18.6707,
    x2: 8.81535,
    y2: 18.6941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC3E88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.418735,
    stopColor: "#B840AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#843FE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4708_66",
    x1: 10.7547,
    y1: 18.6707,
    x2: 11.6144,
    y2: 18.6941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC3E88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.418735,
    stopColor: "#B840AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#843FE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4708_66",
    x1: 13.5538,
    y1: 18.6707,
    x2: 14.4135,
    y2: 18.6941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC3E88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.418735,
    stopColor: "#B840AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#843FE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4708_66",
    x1: 16.3528,
    y1: 18.6707,
    x2: 17.2126,
    y2: 18.6941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC3E88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.418735,
    stopColor: "#B840AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#843FE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_4708_66",
    x1: 19.1519,
    y1: 18.6707,
    x2: 20.0116,
    y2: 18.6941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC3E88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.418735,
    stopColor: "#B840AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#843FE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_4708_66",
    x1: 21.951,
    y1: 18.6707,
    x2: 22.8107,
    y2: 18.6941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC3E88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.418735,
    stopColor: "#B840AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#843FE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_4708_66",
    x1: 24.75,
    y1: 18.6707,
    x2: 25.6098,
    y2: 18.6941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC3E88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.418735,
    stopColor: "#B840AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#843FE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_4708_66",
    x1: 27.5491,
    y1: 18.6707,
    x2: 28.4089,
    y2: 18.6941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC3E88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.418735,
    stopColor: "#B840AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#843FE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_4708_66",
    x1: 30.3482,
    y1: 18.6707,
    x2: 31.2079,
    y2: 18.6941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC3E88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.418735,
    stopColor: "#B840AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#843FE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_4708_66",
    x1: 33.1473,
    y1: 18.6707,
    x2: 34.007,
    y2: 18.6941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC3E88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.418735,
    stopColor: "#B840AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#843FE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_4708_66",
    x1: 14.2535,
    y1: 27.9245,
    x2: 15.1132,
    y2: 27.9479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC3E88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.418735,
    stopColor: "#B840AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#843FE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_4708_66",
    x1: 24.4574,
    y1: 23.4827,
    x2: 31.3338,
    y2: 23.6966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC3E88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.418735,
    stopColor: "#B840AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#843FE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_4708_66",
    x1: 7.74304,
    y1: 4.54617,
    x2: 33.5317,
    y2: 5.31171,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC3E88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.418735,
    stopColor: "#B840AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#843FE8"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.7eaa1e709045cf04a940d5a39cc875fc.svg";
export { ForwardRef as ReactComponent };